// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__U4DSN","empty__image":"Empty_empty__image__FuVhr","empty__title":"Empty_empty__title__eHhCR","empty__btn":"Empty_empty__btn__phmNn"};